import { useDisplayVariant } from 'modules/productDetail'
import * as React from 'react'
import styled from 'styled-components'
import theme from 'theme'
import Amount from 'theme/atoms/Amount'
import CartButton from './CartButton'
import { DeliveryInformation } from 'utils/calculateDeliveryDate'
import useAccount from 'hooks/account/useAccount'
import ChannelPopUp from './ChannelPopUp'
import { isItemChannelRestricted } from 'hooks/account/utils'
import useTranslations from 'hooks/useTranslations'

type Props = {
  setAmount: (val: number) => void
  openFilterDrawer: () => void
  amount: number
  deliveryInformations: DeliveryInformation
}

export default function BuyWrapper(props: Props) {
  const variant = useDisplayVariant()
  const account = useAccount()

  const t = useTranslations<'templates-PDP'>()

  const $amount = React.useRef(null)

  // const channel = useAccount().channel

  const restricted = React.useMemo(
    () => isItemChannelRestricted(variant.data, account.channel),
    [account.channel, variant.data]
  )

  const channelInactive = restricted
    ? account.channel === 'b2b'
      ? 'b2c'
      : 'b2b'
    : null

  return (
    <Wrapper className="BuyWrapper" $fullWidth={restricted}>
      {variant.data.sellable && !restricted && (
        <div className="amount" data-cy-state="has-amount-controls">
          <Amount
            minValue={1}
            maxValue={9999}
            setValue={props.setAmount}
            data-cy-handle-increase="increase-amount"
            data-cy-handle-decrease="decrease-amount"
            data-cy-handle-amount="amount"
            ref={$amount}
            decrease_button_a11y_title={t.asText(
              $amount,
              'templates_PDP_buy_box_buywrapper_a11y_decrease_amount_button'
            )}
            amount_input_a11y_title={t.asText(
              $amount,
              'templates_PDP_buy_box_buywrapper_a11y_amount_input'
            )}
            increase_button_a11y_title={t.asText(
              $amount,
              'templates_PDP_buy_box_buywrapper_a11y_increase_amount_button'
            )}
          />
        </div>
      )}
      {restricted && (
        // eslint-disable-next-line @kaminrunde/firescout/jsx-expression-needs-state
        <ChannelPopUp channelInactive={channelInactive} />
      )}
      <CartButton
        amount={props.amount}
        openFilterDrawer={props.openFilterDrawer}
        deliveryInformations={props.deliveryInformations}
        channelInactive={channelInactive}
      />
    </Wrapper>
  )
}

const Wrapper = styled.div<{ $fullWidth: boolean }>`
  ${(p) => (p.$fullWidth ? 'display: block;' : 'display: flex;')}

  margin-bottom: ${theme.spacing('xs')};
  flex-wrap: nowrap;
  gap: ${theme.spacing('m')};

  position: relative;

  > .amount {
    display: flex;
    height: 100%;
    > label {
      height: 2.625rem;
      > button {
        width: 2.625rem;
        height: 100%;
      }
      > input {
        width: 3.25rem;
        height: 100%;
      }
    }
  }
`
